var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBgTrustDonors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 133,
    viewBox: "0 0 295 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.75H200.24C210.181 36.75 218.24 28.6911 218.24 18.75C218.24 8.80887 226.299 0.75 236.24 0.75L295 0.75",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.75H200.24C210.181 36.75 218.24 28.6911 218.24 18.75C218.24 8.80887 226.299 0.75 236.24 0.75L295 0.75",
    stroke: "url(#paint0_linear_171730_2750)",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 95.75H200.24C210.181 95.75 218.24 103.809 218.24 113.75C218.24 123.691 226.299 131.75 236.24 131.75L295 131.75",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 95.75H200.24C210.181 95.75 218.24 103.809 218.24 113.75C218.24 123.691 226.299 131.75 236.24 131.75L295 131.75",
    stroke: "url(#paint1_linear_171730_2750)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171730_2750",
    x1: 91.8112,
    y1: 49.5,
    x2: 147.411,
    y2: 18.5899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231949,
    stopColor: "#3292FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569175,
    stopColor: "#3292FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3292FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_171730_2750",
    x1: 91.8112,
    y1: 83,
    x2: 147.411,
    y2: 113.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231949,
    stopColor: "#3292FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569175,
    stopColor: "#3292FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3292FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBgTrustDonors);
export default __webpack_public_path__ + "static/media/right_bg_trust_donors.e05d5840090915e0a4a998cb58433366.svg";
export { ForwardRef as ReactComponent };